import { jsx as _jsx } from "react/jsx-runtime";
import Aligner from "../_private/Aligner/index.js";
import s from "./MenuItem.module.css";
const MenuItemAligner = (props) => {
    return (_jsx(Aligner, { ...props, side: props.side || "inline", className: [s.aligner, props.className] }));
};
MenuItemAligner.displayName = "MenuItem.Aligner";
export default MenuItemAligner;
